export const USER_AUTHENTICATED_EVENT = 'USER_AUTHENTICATED';
